<template>
  <div class="board" ref="board">
    <div class="head">
      <div>
        <div class="title">车间进度</div>
        <div class="sub">已受理、生产中、已中断的工单。交期已过标为逾期，今天起两天内标为临期。每 30 秒刷新。</div>
      </div>
      <div class="head-right">
        <span class="clock">{{ clock }}</span>
        <el-button size="mini" @click="load">刷新</el-button>
        <el-button size="mini" @click="toggleFull">{{ full ? '退出全屏' : '全屏' }}</el-button>
      </div>
    </div>
    <div class="stats">
      <div class="stat" :class="{ on: filter === '' }" @click="filter = ''">
        <div class="num">{{ summary.total || 0 }}</div>
        <div class="label">在制</div>
      </div>
      <div class="stat danger" :class="{ on: filter === 'OVERDUE' }" @click="filter = 'OVERDUE'">
        <div class="num">{{ summary.overdue || 0 }}</div>
        <div class="label">逾期</div>
      </div>
      <div class="stat warn" :class="{ on: filter === 'DUE_SOON' }" @click="filter = 'DUE_SOON'">
        <div class="num">{{ summary.dueSoon || 0 }}</div>
        <div class="label">临期</div>
      </div>
      <div class="stat" :class="{ on: filter === 'INTERRUPTED' }" @click="filter = 'INTERRUPTED'">
        <div class="num">{{ summary.interrupted || 0 }}</div>
        <div class="label">中断</div>
      </div>
    </div>
    <div v-loading="loading" class="grid">
      <div v-if="!loading && !shown.length" class="empty">没有符合条件的工单</div>
      <div v-for="row in shown" :key="row.orderId" class="card" :class="cardClass(row)">
        <div class="card-top">
          <span class="code">{{ row.orderCode }}</span>
          <span class="badge">{{ dueText(row) }}</span>
        </div>
        <div class="name">{{ row.productNumber || '' }} {{ row.productName || row.orderName || '' }}</div>
        <div class="meta">{{ stateText(row.orderState) }}　{{ row.productionLineName || '未排产线' }}</div>
        <div class="now">当前工序：{{ row.currentOperation }}</div>
        <el-progress :percentage="pct(row)" :stroke-width="10" :show-text="false" :color="barColor(row)" />
        <div class="qty">完成 {{ num(row.doneQty) }} / 计划 {{ num(row.plannedQty) }}　{{ pct(row) }}%</div>
        <div class="steps">
          <span v-if="!(row.steps && row.steps.length)" class="step muted">无工序</span>
          <span
            v-for="(step, index) in row.steps"
            :key="index"
            class="step"
            :class="stepClass(step.taskState)">
            {{ step.operationName }}
          </span>
        </div>
        <div class="deadline">交期 {{ row.deadline || '未填' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { progressBoard } from '../../api/productionOrder'

export default {
  data() {
    return {
      loading: false,
      filter: '',
      list: [],
      summary: {},
      clock: '',
      full: false,
      timer: null,
      clockTimer: null
    }
  },
  computed: {
    shown() {
      if (this.filter === 'INTERRUPTED') {
        return this.list.filter(row => row.orderState === '05')
      }
      if (!this.filter) return this.list
      return this.list.filter(row => row.dueFlag === this.filter)
    }
  },
  created() {
    this.tick()
    this.load()
    this.timer = setInterval(this.load, 30000)
    this.clockTimer = setInterval(this.tick, 1000)
    document.addEventListener('fullscreenchange', this.onFullChange)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.clockTimer)
    document.removeEventListener('fullscreenchange', this.onFullChange)
  },
  methods: {
    tick() {
      const d = new Date()
      const p = n => (n < 10 ? '0' : '') + n
      this.clock = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
        + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
    },
    load() {
      this.loading = true
      progressBoard().then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.summary = body.summary || {}
      }).finally(() => {
        this.loading = false
      })
    },
    pct(row) {
      const n = Number(row.progressPct)
      if (!Number.isFinite(n) || n < 0) return 0
      return n > 100 ? 100 : Math.round(n)
    },
    num(v) {
      if (v === null || v === undefined || v === '') return '0'
      return String(v)
    },
    stateText(s) {
      return { '01': '已受理', '02': '生产中', '05': '已中断' }[s] || s || '-'
    },
    dueText(row) {
      if (row.dueFlag === 'OVERDUE') return '逾期 ' + Math.abs(row.dueDays) + ' 天'
      if (row.dueFlag === 'DUE_SOON') return row.dueDays === 0 ? '今天到期' : row.dueDays + ' 天后到期'
      if (row.dueFlag === 'ON_TIME') return '交期内'
      return '未填交期'
    },
    cardClass(row) {
      if (row.orderState === '05') return 'is-stop'
      if (row.dueFlag === 'OVERDUE') return 'is-over'
      if (row.dueFlag === 'DUE_SOON') return 'is-soon'
      return ''
    },
    barColor(row) {
      if (row.dueFlag === 'OVERDUE') return '#f56c6c'
      if (row.dueFlag === 'DUE_SOON') return '#e6a23c'
      return '#67c23a'
    },
    stepClass(state) {
      if (state === '02') return 'done'
      if (state === '01') return 'run'
      return 'wait'
    },
    onFullChange() {
      this.full = !!document.fullscreenElement
    },
    toggleFull() {
      const el = this.$refs.board
      if (!el) return
      if (document.fullscreenElement) {
        document.exitFullscreen()
      } else if (el.requestFullscreen) {
        el.requestFullscreen()
      }
    }
  }
}
</script>

<style scoped>
.board {
  background: #0f172a;
  color: #e2e8f0;
  min-height: calc(100vh - 120px);
  padding: 16px;
  border-radius: 8px;
}
.board:fullscreen { min-height: 100vh; overflow: auto; }
.head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; }
.title { font-size: 22px; font-weight: 700; }
.sub { margin-top: 6px; color: #94a3b8; font-size: 13px; }
.head-right { display: flex; align-items: center; gap: 8px; }
.clock { font-variant-numeric: tabular-nums; color: #cbd5e1; margin-right: 8px; }
.stats { display: flex; gap: 12px; margin: 16px 0; }
.stat {
  min-width: 110px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
}
.stat.on { border-color: #38bdf8; }
.stat .num { font-size: 26px; font-weight: 700; }
.stat .label { color: #94a3b8; font-size: 12px; }
.stat.danger .num { color: #f87171; }
.stat.warn .num { color: #fbbf24; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 12px; }
.card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 14px;
}
.card.is-over { border-color: #ef4444; }
.card.is-soon { border-color: #f59e0b; }
.card.is-stop { border-color: #64748b; }
.card-top { display: flex; justify-content: space-between; gap: 8px; align-items: center; }
.code { font-weight: 700; }
.badge { font-size: 12px; color: #cbd5e1; }
.is-over .badge { color: #fca5a5; }
.is-soon .badge { color: #fcd34d; }
.name { margin-top: 8px; font-size: 15px; }
.meta, .qty, .deadline { margin-top: 6px; color: #94a3b8; font-size: 12px; }
.now { margin: 8px 0; color: #e2e8f0; }
.steps { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.step {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #334155;
}
.step.done { background: #14532d; color: #bbf7d0; }
.step.run { background: #1d4ed8; color: #dbeafe; }
.step.wait { color: #cbd5e1; }
.step.muted { color: #94a3b8; }
.empty { grid-column: 1 / -1; text-align: center; color: #94a3b8; padding: 48px 0; }
</style>
